/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { getDetailPagoConsultaHQM } from "../../Api";
import { dateToLocaleYears, formatCurrency } from '../../Functions'

const TableDetailHMQ = ({fechaproceso}) => {

  const [state, setState] = useState({
    data: [],
    loading: true
  });

  const loadData = async () => {
    const _response = await getDetailPagoConsultaHQM({ fecha: dateToLocaleYears(fechaproceso) });
    if (_response.status) {
      setState({
        data: _response.data.records,
        loading: false,
      });
    }
  }

  useEffect(() => {
    loadData();
  }, [fechaproceso])

  return (
    <>
      <div className="row">
        <div className={`col-12 table-responsive ${state.loading ? 'table-loading-overlay' : ''}`} style={{height: '400px'}}>
          <table className="table table-bordered table-payment-detailtype">
            <thead className="text-white">
              <tr>
                <th> N° Rol</th>
                <th> Sucursal</th>
                <th> Nombre Paciente</th>
                <th> Fecha Hosp.</th>
                <th> Previsión </th>
                <th> Código Prestación </th>
                <th> Acción </th>
                <th> N° </th>
                <th> Tipo PAM </th>
                <th> Monto Prestación </th>
                <th> Monto Pagos Anteriores </th>
                <th> Monto Bono / Seguro </th>
                <th> Monto Copago </th>
                <th> Saldo </th>
                <th> Estado </th>
              </tr>
            </thead>
            <tbody className="text-gray-800">
              {state?.data?.map((item, index) => (
                <tr key={index}>
                  <td> { item.numerrol } </td>
                  <td> { item.nombre_sucursal } </td>
                  <td> { item.nombrepaciente } </td>
                  <td> { item.fechahospitalizacion } </td>
                  <td> { item.prevision } </td>
                  <td> { item.codigoprestacion } </td>
                  <td> { item.accion } </td>
                  <td> { item.cantidad } </td>
                  <td> { item.tipopam } </td>
                  <td> { formatCurrency(item.montoproestacion) } </td>
                  <td> { formatCurrency(item.montopagoanteriores) } </td>
                  <td> { formatCurrency(item.montobonificado) } </td>
                  <td> { formatCurrency(item.montocopago) } </td>
                  <td> { formatCurrency(item.saldo) } </td>
                  <td> { item.estado } </td>
              </tr>))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  )
}

export default TableDetailHMQ